import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, ButtonGroup, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCheckCircle, FaClock, FaEdit, FaFileInvoice, FaFilePdf, FaFilter, FaMoneyBillWave, FaPlus, FaPrint, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import BonLivraisonForm from './BonLivraisonForm';
import InvoiceForm from './InvoiceForm';
import { productActions } from '../../sagas/productSlice';
import { ROLE_AGENT, ROLE_CAISSIER } from '../../helpers/constants';

const DeliveryList = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [filteredList, setFilteredList] = useState([]);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const role = useSelector((state) => state.auth.role);
    const { businessName, email, address, telephone } = useSelector(state => state.auth);
    const fullName = useSelector(state => state.auth.fullName);
    const [statistics, setStatistics] = useState({
        totalOrders: 0, totalAmounts: 0,
        totalEnPreparation: 0, totalAmountsEnPeparation: 0, totalPaye: 0,
        totalAmountsPaye: 0, totalOnline: 0, totalAmountsOnline: 0,
        totalEspece: 0, totalAmountsEspece: 0, totalCarte: 0, totalAmountsCarte: 0
    })
    const [period, setPeriod] = useState('today');
    const [statsFilter, setStatsFilter] = useState(null);

    const isCaissier = role === ROLE_CAISSIER;
    const isAgent = role === ROLE_AGENT;
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });


    const navigate = useNavigate();

    useEffect(() => {
        let payload = {
            ...filters
        };
        dispatch(deliveryActions.list(payload));
    }, [filters]);

    const handleFilterChange = (e) => {
        const value = e.target.value;
        setFilter(value);
    };

    const handleFilter = () => {

    }

    useEffect(() => {
        setFilteredList(list.filter((commande) => {
            const queryLower = filter.toLowerCase();
            return (
                commande.numero.toLowerCase().includes(queryLower) ||
                (commande.clientNom && commande.clientNom.toLowerCase().includes(queryLower))
            );
        }));
    }, [filter]);

    useEffect(() => {
        if (!list || list.length === 0) return;

        // Filter list by createdAt and exclude RETOUR
        const filtered = list.filter(item => {
            return item.status !== 'RETOUR';
        });

        // Initialize stats
        const stats = {
            totalOrders: filtered.length,
            totalAmounts: 0,
            totalEnPreparation: 0,
            totalAmountsEnPeparation: 0,
            totalPaye: 0,
            totalAmountsPaye: 0,
            totalOnline: 0,
            totalAmountsOnline: 0,
            totalEspece: 0,
            totalAmountsEspece: 0,
            totalCarte: 0,
            totalAmountsCarte: 0
        };

        // Aggregate values
        filtered.forEach(item => {
            const amount = item.montantTotalTTC || 0;
            stats.totalAmounts += amount;

            if (item.status === "EN_PREPARATION") {
                stats.totalEnPreparation += 1;
                stats.totalAmountsEnPeparation += amount;
            }

            if (item.status === "PAYE") {
                stats.totalPaye += 1;
                stats.totalAmountsPaye += amount;
            }

            if (item.estOnline) {
                stats.totalOnline += 1;
                stats.totalAmountsOnline += amount;
            }

            if (item.modePaiement === "ESPECE") {
                stats.totalEspece += 1;
                stats.totalAmountsEspece += amount;
            }

            if (item.modePaiement === "CARTE_BANCAIRE") {
                stats.totalCarte += 1;
                stats.totalAmountsCarte += amount;
            }

        });

        setStatistics(stats);
        let result = [...filtered];
        if (statsFilter) {

            if (statsFilter === "EN_PREPARATION") {
                result = result.filter(item => item.status === "EN_PREPARATION");
            }

            if (statsFilter === "PAYE") {
                result = result.filter(item => item.status === "PAYE");
            }

            if (statsFilter === "ONLINE") {
                result = result.filter(item => item.estOnline === true);
            }

            if (statsFilter === "ESPECE") {
                result = result.filter(item => item.modePaiement === "ESPECE");
            }

            if (statsFilter === "CARTE") {
                result = result.filter(item => item.modePaiement === "CARTE_BANCAIRE");
            }

            if (statsFilter === "ALL") {
                // no filter
            }
        }

        setFilteredList(result);
    }, [list, statsFilter]);


    useEffect(() => {
        dispatch(productActions.findAllUnites());

    }, [list, dispatch]);

    const handleEdit = (bl) => {
        navigate(`/sales/${bl.id}`);
    }

    const handleCheckout = (bl) => {
        navigate(`/caisse/${bl.id}`);
    }

    const printReceipt = async (receiptData) => {
        try {
            // Create PDF with 80mm thermal printer dimensions
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 300] // 80mm width, longer for customer receipt
            });

            doc.setFont('helvetica');

            let yPosition = 5;
            const pageWidth = 80;
            const margin = 3;
            const contentWidth = pageWidth - (margin * 2);

            // Business Header
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text(businessName || 'MatjarPos', pageWidth / 2, yPosition, { align: 'center' });
            yPosition += 6;

            // Business Address
            if (address) {
                doc.setFontSize(8);
                doc.setFont('helvetica', 'normal');
                const addressLines = doc.splitTextToSize(address, contentWidth);
                addressLines.forEach((line, index) => {
                    doc.text(line, pageWidth / 2, yPosition + (index * 3), { align: 'center' });
                });
                yPosition += (addressLines.length * 3) + 3;
            }

            // Business Contact Info
            doc.setFontSize(7);
            if (telephone) {
                doc.text(`Tel: ${telephone}`, pageWidth / 2, yPosition, { align: 'center' });
                yPosition += 3;
            }
            if (email) {
                doc.text(`Email: ${email}`, pageWidth / 2, yPosition, { align: 'center' });
                yPosition += 5;
            }

            // Receipt Title
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('RECU DE VENTE', pageWidth / 2, yPosition, { align: 'center' });
            yPosition += 6;

            // Separator line
            doc.setLineWidth(0.2);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 4;

            // Receipt Details
            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.text('Recu No:', margin, yPosition);
            doc.setFont('helvetica', 'normal');
            doc.text(receiptData?.numero || '---', margin + 20, yPosition);
            yPosition += 4;

            doc.setFont('helvetica', 'bold');
            doc.text('Date:', margin, yPosition);
            doc.setFont('helvetica', 'normal');
            const currentDate = receiptData?.paidAt || 'N/A';
            doc.text(currentDate, margin + 12, yPosition);
            yPosition += 4;

            doc.setFont('helvetica', 'bold');
            doc.text('Caissier:', margin, yPosition);
            doc.setFont('helvetica', 'normal');
            doc.text(receiptData?.paidBy || '---', margin + 20, yPosition);
            yPosition += 6;

            // Customer Information
            if (receiptData?.clientNom) {
                doc.setFont('helvetica', 'bold');
                doc.text('Client:', margin, yPosition);
                doc.setFont('helvetica', 'normal');
                const clientLines = doc.splitTextToSize(receiptData.clientNom, contentWidth - 15);
                clientLines.forEach((line, index) => {
                    doc.text(line, margin + 15, yPosition + (index * 3));
                });
                yPosition += (clientLines.length * 3) + 3;
            } else {
                doc.setFont('helvetica', 'normal');
                doc.text('Client: Passager', margin, yPosition);
                yPosition += 5;
            }

            // Separator line
            doc.setLineWidth(0.1);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 3;

            // Items Header
            doc.setFontSize(7);
            doc.setFont('helvetica', 'bold');
            doc.text('Article', margin, yPosition);
            doc.text('Qte', pageWidth - 35, yPosition);
            doc.text('Prix', pageWidth - 22, yPosition);
            doc.text('Total', pageWidth - 8, yPosition, { align: 'right' });
            yPosition += 3;

            doc.setLineWidth(0.05);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 3;

            // Items List
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);

            let subtotal = 0;

            receiptData?.lignes?.forEach((item, index) => {
                // Check if we need a new page
                if (yPosition > 250) {
                    doc.addPage([80, 300]);
                    yPosition = 5;
                }

                // Item name (split if too long)
                const itemName = item.articleNom.length > 25 ? item.articleNom.substring(0, 22) + '...' : item.articleNom;
                doc.text(itemName, margin, yPosition);
                yPosition += 5;

                // Item code (smaller text)
                doc.setFontSize(8);
                doc.text(`Code: ${item.articleCode}`, margin + 2, yPosition);
                yPosition += 3;

                // Quantity, unit price, and total on same line
                doc.setFontSize(6);
                const uniteLibelle = (() => {
                    const libelle = unites.find(u => u.code === item.unite)?.libelle;
                    // if (libelle === 'METRE') return 'M';
                    // if (libelle === 'COUPON') return 'CP';
                    return libelle;
                })();

                doc.text(`${item.quantiteLivree} ${uniteLibelle}`, pageWidth - 40, yPosition - 2);
                doc.setFontSize(7);

                doc.text(`${formatPrice(item.prixUnitaireTTC, false)}`, pageWidth - 27, yPosition - 2);
                doc.text(`${formatPrice(item.montantTTC, false)}`, pageWidth - 3, yPosition - 2, { align: 'right' });

                yPosition += 2;
                subtotal += parseFloat(item.montantTTC);

                // Separator line between items
                if (index < receiptData.lignes.length - 1) {
                    doc.setLineWidth(0.02);
                    doc.line(margin + 5, yPosition, pageWidth - margin - 5, yPosition);
                    yPosition += 4;
                }
            });

            yPosition += 3;

            // Totals Section
            doc.setLineWidth(0.1);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 4;

            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');

            // Subtotal
            doc.text('Sous-total:', margin, yPosition);
            doc.text(formatPrice(receiptData?.montantTotalHT || subtotal, false), pageWidth - 8, yPosition, { align: 'right' });
            yPosition += 4;

            // Tax if applicable
            if (receiptData?.montantTotalTaxe && receiptData.montantTotalTaxe > 0) {
                doc.text('TVA:', margin, yPosition);
                doc.text(formatPrice(receiptData.montantTotalTaxe, false), pageWidth - 8, yPosition, { align: 'right' });
                yPosition += 4;
            }

            // Total
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.text('TOTAL:', margin, yPosition);
            doc.text(formatPrice(receiptData?.montantTotalTTC || subtotal, false), pageWidth - 8, yPosition, { align: 'right' });
            yPosition += 6;

            // Payment Information
            doc.setLineWidth(0.1);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 4;

            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');

            // Payment method
            const paymentMethodText = receiptData.modePaiement === 'ESPECE' ? 'Espèces' :
                receiptData.modePaiement === 'CARTE_BANCAIRE' ? 'Carte Bancaire' :
                    receiptData.modePaiement;
            doc.text(`Paiement: ${paymentMethodText}`, margin, yPosition);
            yPosition += 4;

            // Amount paid
            if (receiptData.montantPaye) {
                doc.text('Montant reçu:', margin, yPosition);
                doc.text(formatPrice(receiptData.montantPaye, false), pageWidth - 8, yPosition, { align: 'right' });
                yPosition += 4;

                // Change (only for cash payments)
                if (receiptData.modePaiement === 'ESPECE' && receiptData.montantPaye > receiptData.montantTotalTTC) {
                    doc.text('Monnaie:', margin, yPosition);
                    doc.text(formatPrice(receiptData.montantPaye - receiptData.montantTotalTTC, false), pageWidth - 8, yPosition, { align: 'right' });
                    yPosition += 6;
                }
            }

            // Footer Messages
            yPosition += 5;
            doc.setLineWidth(0.1);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += 4;

            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text('MERCI DE VOTRE VISITE!', pageWidth / 2, yPosition, { align: 'center' });
            yPosition += 5;

            doc.setFontSize(7);
            doc.setFont('helvetica', 'normal');
            doc.text('Gardez votre reçu', pageWidth / 2, yPosition, { align: 'center' });
            yPosition += 3;
            doc.text('Echange possible sous 7 jours', pageWidth / 2, yPosition, { align: 'center' });
            yPosition += 5;

            // QR Code placeholder or additional info
            doc.setFontSize(6);
            doc.text('Powered by MatjarPos', pageWidth / 2, yPosition, { align: 'center' });



            // Also open in new window for immediate printing
            const pdfBlob = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl);

        } catch (error) {
            console.error("Error generating customer receipt:", error);
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur lors de la génération du reçu client'
            });
        }
    };

    const handleCancel = (bl) => {

        Swal.fire({
            title: t('commande.deleteConfirmTitle'),
            text: t('commande.deleteConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    const payload = {
                        id: bl.id,
                        onSuccess: () => {
                            Swal.fire(t('commande.deleted'), '', 'success');
                            let payload = {
                                ...filters
                            };
                            dispatch(deliveryActions.list(payload));
                        }
                    }
                    dispatch(deliveryActions.annuler(payload));


                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('product.deleteError')
                    });
                }
            }
        });
    }


    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('commande.list')}
                            </h4>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row>
                                    <Col md={6}>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <FaSearch />
                                            </span>
                                            <input
                                                type="text"
                                                placeholder={t('commande.filterPlaceholder')}
                                                value={filter}
                                                onChange={handleFilterChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormGroup className="d-flex align-items-center gap-2 mb-0">
                                            <Label for="dateFrom" className="mb-0 w-50">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                                className="flex-grow-1"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col md={3} sm={6} xs={12}>
                                        <FormGroup className="d-flex align-items-center gap-2 mb-0">
                                            <Label for="dateTo" className="mb-0 w-50">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                                className="flex-grow-1"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            {/* Summary Statistics Box */}
                            <div className="row mb-4">
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
            ${statsFilter === "ALL" ? "border border-primary shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("ALL")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                        {t('delivery.total')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalOrders}
                                                    </div>
                                                    <div className="text-xs text-primary mt-2">
                                                        {formatPrice(statistics.totalAmounts)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-primary bg-opacity-10 p-3">
                                                    <FaTruck className="text-primary h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
            ${statsFilter === "EN_PREPARATION" ? "border border-warning shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("EN_PREPARATION")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                        {t('delivery.enpreparation')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalEnPreparation}
                                                    </div>
                                                    <div className="text-xs text-warning mt-2">
                                                        {formatPrice(statistics.totalAmountsEnPeparation)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-warning bg-opacity-10 p-3">
                                                    <FaFileInvoice className="text-warning h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
                                        ${statsFilter === "PAYE" ? "border border-info shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("PAYE")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                        {t('delivery.paye')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalPaye}
                                                    </div>
                                                    <div className="text-xs text-info mt-2">
                                                        {formatPrice(statistics.totalAmountsPaye)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-info bg-opacity-10 p-3">
                                                    <FaMoneyBillWave className="text-info h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
            ${statsFilter === "ONLINE" ? "border border-success shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("ONLINE")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                        {t('delivery.enLigne')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalOnline}
                                                    </div>
                                                    <div className="text-xs text-success mt-2">
                                                        {formatPrice(statistics.totalAmountsOnline)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-info bg-opacity-10 p-3">
                                                    <FaMoneyBillWave className="text-success h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Espèces */}
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
            ${statsFilter === "ESPECE" ? "border border-secondary shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("ESPECE")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                                                        {t('delivery.espece')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalEspece}
                                                    </div>
                                                    <div className="text-xs text-secondary mt-2">
                                                        {formatPrice(statistics.totalAmountsEspece)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-secondary bg-opacity-10 p-3">
                                                    <FaMoneyBillWave className="text-secondary h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Carte Bancaire */}
                                <div className="col-md-2">
                                    <div
                                        className={`card shadow-sm bg-gradient h-100 pointer 
            ${statsFilter === "CARTE" ? "border border-dark shadow-lg" : ""}`}
                                        onClick={() => setStatsFilter("CARTE")}
                                    >
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                                                        {t('delivery.carte')}
                                                    </div>
                                                    <div className="h3 mb-0 font-weight-bold">
                                                        {statistics.totalCarte}
                                                    </div>
                                                    <div className="text-xs text-dark mt-2">
                                                        {formatPrice(statistics.totalAmountsCarte)}
                                                    </div>
                                                </div>
                                                <div className="rounded-circle bg-dark bg-opacity-10 p-3">
                                                    <FaMoneyBillWave className="text-dark h3 mb-0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table className="table table-hover table-striped table-bordered">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('sale.estCadeau')}</th>
                                        <th className="align-middle text-center">{t('delivery.modePaiement')}</th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.online', 'Online')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredList.map((bl) => (
                                        <tr key={bl.id}>
                                            {/* Add checkbox for each row */}

                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{bl.createdAt}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantPaye, false)}</td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={!!bl.estCadeau}
                                                    disabled
                                                    style={{ pointerEvents: 'none', accentColor: '#0d6efd' }}
                                                />
                                            </td>
                                            <td className="align-middle text-center">
                                                {bl.modePaiement === 'ESPECE' && (
                                                    <span className="badge bg-info">{t('delivery.espece')}</span>
                                                )}
                                                {bl.modePaiement === 'CARTE_BANCAIRE' && (
                                                    <span className="badge bg-secondary">{t('delivery.carte')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-info">{t('delivery.gift')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                                {bl.status === 'PAYE' && (
                                                    <span className="badge bg-success">{t('delivery.paye')}</span>
                                                )}
                                            </td>

                                            <td className="align-middle text-center">
                                                {bl.estOnline ? (
                                                    <span className="badge bg-info">Online</span>
                                                ) : (
                                                    <span className="badge bg-secondary">Offline</span>
                                                )}
                                            </td>

                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {bl.status === 'EN_PREPARATION' && <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        size='sm'
                                                        onClick={() => handleEdit(bl)}
                                                        className="me-1"
                                                    >
                                                        Modifier <FaEdit />
                                                    </Button>
                                                    }

                                                    {isCaissier && bl.status === 'EN_PREPARATION' && <Button
                                                        color="success"
                                                        title={t('commande.checkout')}
                                                        onClick={() => handleCheckout(bl)}
                                                        className="me-1"
                                                        size='sm'
                                                    >
                                                        Encaisser <FaCheckCircle />
                                                    </Button>
                                                    }

                                                    {
                                                        isCaissier && <Button
                                                            color="danger"
                                                            title={t('commande.cancel')}
                                                            onClick={() => handleCancel(bl)}
                                                            className="me-1"
                                                            size='sm'
                                                        >
                                                            Annuler <FaTrash />
                                                        </Button>
                                                    }




                                                    {
                                                        isCaissier && (bl.status === 'PAYE' || bl.status === 'LIVRE') && <Button
                                                            color="secondary"
                                                            title={t('commande.checkout')}
                                                            onClick={() => printReceipt(bl)}
                                                            className="me-1"
                                                        >
                                                            Imprimer <FaPrint />
                                                        </Button>
                                                    }

                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredList.length === 0 && (
                                        <tr>
                                            <td colSpan="15" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </>)}
                </CardBody>
            </Card>
        </Container>
    );
};

export default DeliveryList;



